import { EquipmentTypeFamilyDao } from '@rock/db-admin';
import type { EquipmentTypeId } from '@rock/types';
import { familyOf, shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const equipmentTypeFamilyDao = new EquipmentTypeFamilyDao();

/** Every type family, live — the Families tab and both matchers' type gate as admin explains it. */
export const equipmentTypeFamiliesState = equipmentTypeFamilyDao.equipmentTypeFamiliesAtom();

/** The family a catalog type belongs to, if any — the Type panels of the model and document pages. */
export const equipmentTypeFamilyOfState = atomFamily(
    (typeId: EquipmentTypeId) => atom(async (get) => familyOf(typeId, await get(equipmentTypeFamiliesState))),
    shallowEqual,
);
